module.exports = __webpack_public_path__ + "img/当日挂号.9cb7b069.png";